import { createSlice, current, PayloadAction } from '@reduxjs/toolkit'
import { InboxSectionEnum } from 'Modules/Communication/shared/models/Inbox'
import { merge } from 'shared/utils/mergeObjects'
import { SmsFilters, SmsFiltersUpdate } from './types'

const emptyDates = () => ({
  received: { from: undefined, to: undefined },
  sent: { from: undefined, to: undefined },
  deleted: { from: undefined, to: undefined },
  processed: { from: undefined, to: undefined },
})

const initialFilters: SmsFilters = {
  searchText: '',
  queryStatus: InboxSectionEnum.Sent,
  labelId: '',
  page: 1,
  sortcolumn: 'SentDate',
  dates: emptyDates(),
}

const initialState = {
  filters: initialFilters,

  current: null as string | null,

  marked: [] as string[],
  singleListActionId: null as string | null,
}

const smsMessagesSlice = createSlice({
  name: 'smsMessages',
  initialState,
  reducers: {
    setSmsFilters: (state, action: PayloadAction<SmsFiltersUpdate>) => {
      const shouldResetMarked = Object.keys(action.payload).some((item) =>
        ['labelId', 'queryStatus', 'searchText'].includes(item)
      )

      state.filters = merge(current(state.filters), {
        ...action.payload,
        page: 1,
      })
      if (shouldResetMarked) state.marked = []
    },
    requestMoreSms: (state) => {
      state.filters.page += 1
    },
    updateSmsSection: (
      state,
      action: PayloadAction<{ section: InboxSectionEnum; sortcolumn: string }>
    ) => {
      const { section, sortcolumn } = action.payload

      state.filters.queryStatus = section
      state.filters.sortcolumn = sortcolumn
      state.filters.page = 1
      state.filters.dates = emptyDates()
      state.marked = []
    },
    toggleSmsMarked: (state, action: PayloadAction<string>) => {
      const id = action.payload

      if (state.marked.includes(id)) {
        state.marked = state.marked.filter((item) => item !== id)
        return
      }

      state.current = null
      state.marked.push(id)
    },
    resetSmsMarked: (state) => {
      state.marked = []
    },
    setCurrentSms: (state, action: PayloadAction<{ id: string | null }>) => {
      state.current = action.payload.id
    },
    resetCurrentSms: (state) => {
      state.current = null
    },
    removeSmsFromList: (state, _action: PayloadAction<string[]>) => {
      state.marked = []
    },
    setSingleListSmsActionId: (state, action: PayloadAction<string | null>) => {
      state.singleListActionId = action.payload
    },
    removeSmsLabel: (state, _action: PayloadAction<string>) => {
      if (state.filters.queryStatus === InboxSectionEnum.All)
        state.current = null
    },
  },
})

export const {
  setSmsFilters,
  requestMoreSms,
  updateSmsSection,
  toggleSmsMarked,
  resetSmsMarked,
  setCurrentSms,
  resetCurrentSms,
  removeSmsFromList,
  setSingleListSmsActionId,
  removeSmsLabel,
} = smsMessagesSlice.actions

export default smsMessagesSlice.reducer
